<ngx-select [allowClear]="false" [items]="years" optionValueField="value" optionTextField="name"
    [(ngModel)]="selectedYear" placeholder="Variable" (select)="onYearChange($event)">

    <ng-template ngx-select-option-not-found let-input>
        "{{input}}" no encontrada
    </ng-template>

</ngx-select>
